import classNames from 'classnames';
import dynamic from 'next/dynamic';
import React from 'react';

import { useBoolean } from '@sravni/react-utils';

import styles from './wysiwyg.module.scss';

const ReactQuill = dynamic(
  async () => {
    const { default: RQ } = await import('react-quill');

    return (props: React.ComponentProps<typeof RQ> & { forwardedRef: React.Ref<any> }) => {
      const { forwardedRef, ...rest } = props;
      return <RQ ref={forwardedRef} {...rest} />;
    };
  },
  { ssr: false },
);

interface IProps {
  textValue: string;
  placeholder: string;
  handleTextChange: (value: string) => void;
  invalid: boolean;
}

export const Wysiwyg = React.forwardRef<any, IProps>(({ textValue, placeholder, handleTextChange, invalid }, ref) => {
  const [focused, setFocused] = useBoolean(false);

  const modules = {
    toolbar: [['bold', 'italic'], [{ list: 'ordered' }, { list: 'bullet' }], ['link']],
  };

  const _classNames = classNames(styles.wrapper, {
    [styles['wrapper--invalid']]: invalid,
    [styles['wrapper--focused']]: focused,
  });

  return (
    <div className={_classNames}>
      <ReactQuill
        forwardedRef={ref}
        value={textValue}
        onChange={handleTextChange}
        placeholder={placeholder}
        modules={modules}
        formats={['bold', 'italic', 'list', 'bullet', 'link']}
        onFocus={setFocused.on}
        onBlur={setFocused.off}
      />
    </div>
  );
});
